import { useState } from "react";
import {
    Box,
    Typography,
    Rating,
    useTheme,
    useMediaQuery,
    Container,
    Grid,
} from "@mui/material";
import { TestimonialImage } from "../../../../assets/images";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, EffectFade, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { useLocation } from "react-router-dom";

const TestimonialCard = () => {
    const location = useLocation();
    const isHome = location?.pathname === "/home";
    const [activeIndex, setActiveIndex] = useState(0);
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    const handleNavigationClick = (index) => {
        setActiveIndex(index);
    };


    const testimonials = [
        {
            id: 1,
            name: "Aneshia Barr",
            title: "Client and Patient Educator",
            rating: 5,
            image: TestimonialImage,
            testimonial:
                "I'm a 37-year-old active female, newly diagnosed with Systemic Lupus Erythematosus (SLE). Lupus is a multisystem, autoimmune disease that causes irreversible damage to skin, joints, heart, lungs, and in most lupus patients the kidneys (lupus nephritis). I was diagnosed, in an acute flare, and in stage 4 lupus nephritis upon being referred to Central Florida Kidney Specialists. From the very beginning, Dr. Ahmed and his team have been extremely open, communicative, and responsive to questions and concerns I've had regarding my plan of care, medications, navigating this new diagnosis, and exploring multimodal options to putting this lupus in remission. Would 10/10 recommend.",
        },
        {
            id: 2,
            name: "Christina Lafex",
            title: "Actual Client",
            rating: 5,
            testimonial: "I can't say enough good things about my experience with Sonia. For years, I struggled with symptoms that no one could quite explain, and it was incredibly frustrating. After our very first appointment, I could tell she was different, very knowledgeable, attentive, and genuinely invested in helping me feel better. She took the time to dig deep, ask the right questions, and really listened. Thanks to her thorough approach, we were finally able to get to the root cause of my condition and I finally have answers. She's not only an incredible provider but also a kind and compassionate person. I'm so grateful I found her."
        },
        {
            id: 6,
            name: "Heather Hammons",
            title: "Actual Client",
            rating: 5,
            testimonial: "I want to truly thank Sonia and her husband, Dr. Ahmed for all their help identifying my gut issues. I found myself in the hospital for six days and discharge with no real plan to prevent my issues from happening again. I was told if it happened again I would need surgery. Dr Ahmed recommended I meet with Sonia and I am so glad I did. Further testing gave me real answers as to how and why I have suffered with gut issues. I am on the path of healing with supplements and nutritional intake that has helped greatly. I am feeling amazing and with the help of Sonia I plan to stay that way."
        },
        {
            id: 3,
            name: "Alejandra B",
            title: "Actual Client",
            rating: 5,
            testimonial:
                "Dr Ahmed and his team are amazing. Every visit, I was made to feel comfortable and they always listened attentively to my concerns. Dr Ahmed is very knowledgeable and always took the time to explain things to my family and I in a way that we could all understand. I was always made to feel like a priority and I highly recommend him to anyone. I owe so much to Dr Ahmed and his team and I am forever grateful. He is truly a gem and a shining example of what a doctor should be.",
        },
        {
            id: 4,
            name: "Marcia Stoutamire",
            title: "Actual Client",
            rating: 5,
            testimonial: "I have been so impressed with how Dr Ahmed, has focused on treatment of the root cause of my problem - and not just treating symptoms. As it turns out, my problems were not rooted in kidney disease, yet Dr Ahmed has continued to help me navigate a path to better health - and I am so very grateful for the help from both Dr Ahmed and his staff."
        },
        {
            id: 5,
            name: "Oscar Orchilles",
            title: "Actual Client",
            rating: 5,
            testimonial:
                "Dr. Ahmed is a revolutionary in today's landscape. He isolates the root cause of the issue and finds steps you can take to resolve it, not just over prescribe his patients to mask the symptoms. If you want to find a solution to your health and not put a bandaid that has cascading side effects, you should certainly visit Dr. Ahmed. 10/10 on his practice!",
        },
        {
            id: 6,
            name: "Stefanie G.",
            title: "Actual Client",
            rating: 5,
            testimonial:
                "I can’t say enough good things about the care I received from Sonia and Dr. Ahmed. After struggling for years off and on with symptoms of IBD, I finally found a team who truly listened—and more importantly, who looked at the root cause of my issues.  From the start, both Sonia and Dr. Ahmed took a comprehensive, personalized approach. Sonia’s knowledge of nutritional guidance, lifestyle changes, and targeted supplementation has made a major positive impact in feeling better in my daily life.  The improvement of how I feel is amazing. I highly recommend this team. Their knowledge, compassion, and commitment to whole-body healing made all the life changing difference.",
        }
    ];



    return (
        <>
            <Box sx={{
                background: isHome ?  "transparent" : "#799C2E12",
                pb: isHome ? 0 : .5
            }} >
                <Container maxWidth="xl" sx={{
                    my: {
                        md: 3, xs: 4
                    }
                }}>
                    <Grid container>
                        {testimonials[activeIndex]["image"] && (
                            <Grid item size={{ xs: 12, md: 2 }}>
                                {isMobile && (
                                    <Typography
                                        variant="subtitle1"
                                        sx={{
                                            mb: 2,
                                            fontWeight: 600,
                                            letterSpacing: 1,
                                            fontSize: "1.5rem",
                                            fontFamily: "Poppins",
                                            color: "primary.main"
                                        }}
                                    >
                                        Client Experience
                                    </Typography>
                                )}
                                <Box
                                    sx={{
                                        backgroundColor: {
                                            md: "primary.yellow",
                                            xs: "",
                                        },
                                        height: {
                                            md: "600px",
                                            xs: "auto",
                                        },
                                        position: "relative",
                                        display: {
                                            xs: "block",
                                            md: "block",
                                        },
                                        my: {
                                            md: 0,
                                            xs: 4,
                                        }
                                    }}
                                >
                                    <Box
                                        component="img"
                                        src={TestimonialImage}
                                        alt="Testimonial"
                                        onContextMenu={(e) => e.preventDefault()}
                                        draggable={false}
                                        sx={{
                                            position: {
                                                md: "absolute",
                                                xs: "unset",
                                            },
                                            top: "12%",
                                            transform: "translateY(-0%)",
                                            height: "auto",
                                            objectFit: "cover",
                                            width: "100%",
                                            left: 70,
                                            display: {
                                                xs: "block",
                                                md: "block",
                                            },
                                            zIndex: 9,
                                        }}
                                    />
                                </Box>
                            </Grid>
                        )}

                        <Grid item size={{ xs: 12, md: 10 }}>
                            {!isMobile && (
                                <Typography
                                    sx={{
                                        mb: 2,
                                        fontWeight: 600,
                                        letterSpacing: 1,
                                        fontSize: "1.5rem",
                                        fontFamily: "Poppins",
                                        color: "primary.main",
                                        my: 5,
                                        ml: 5,
                                        mt: 4,
                                        mb: 2,
                                        textAlign: "center"
                                    }}
                                >
                                    Client Experience
                                </Typography>
                            )}
                            <Swiper
                                modules={[Navigation, Autoplay]}
                                navigation={false}
                                slidesPerView={1}
                                speed={5500}
                                allowTouchMove={true}
                                loop={true}
                                spaceBetween={130}
                                autoplay={{ delay: 19000, disableOnInteraction: false }}
                                onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                                onSwiper={(swiper) => {
                                    swiper.on('autoplay', () => setActiveIndex(swiper.realIndex));
                                }}
                            >
                                {testimonials.map((testimonial, index) => (
                                    <>

                                        <SwiperSlide key={testimonial.id}>
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    justifyContent: "center",
                                                    gap: 2,
                                                    alignItems: "start",
                                                    width: "100%",
                                                    flexDirection: "column",
                                                    ml: {
                                                        md: 9,
                                                        sm: 5,
                                                    },
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: {
                                                            md: "80%",
                                                            xs: "100%",
                                                        },
                                                        my: {
                                                            md: 4,
                                                            xs: 0
                                                        },
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        justifyContent: "center",
                                                        gap: 2,
                                                        ml: {
                                                            md: 5,
                                                            sm: 0,
                                                        },
                                                    }}
                                                >
                                                    <Typography
                                                        sx={{
                                                            fontSize: "2.0rem",
                                                            fontWeight: 500,
                                                            color: "text.main",
                                                            fontFamily: "Poppins",
                                                        }}
                                                    >
                                                        {testimonial.name}
                                                    </Typography>
                                                    <Typography
                                                        sx={{
                                                            fontSize: "14px",
                                                            mt: -2,
                                                        }}
                                                    >
                                                        {testimonial.title}
                                                    </Typography>
                                                    <Rating
                                                        sx={{
                                                            color: "primary.main",
                                                            fontSize: "1.5rem",
                                                        }}
                                                        value={testimonial.rating}
                                                        readOnly
                                                    />
                                                    <Typography>
                                                        {testimonial.testimonial}
                                                    </Typography>

                                                </Box>
                                            </Box>
                                        </SwiperSlide>
                                    </>
                                ))}
                            </Swiper>
                            <Box sx={{
                                display: "flex",
                                justifyContent: "start",
                                alignItems: "start",
                                gap: {
                                    md: 8, xs: 4
                                },
                                mt: {
                                    md: 8,
                                    xs: 2
                                },
                                ml: {
                                    md: 20,
                                    xs: 0
                                },
                                textAlign: "start",
                            }}>
                                {testimonials.map((_, index) => (
                                    <Typography
                                        key={index}
                                        sx={{
                                            fontSize: "1rem",
                                            fontWeight: 600,
                                            borderBottom: "2px solid",
                                            borderColor:
                                                activeIndex === index
                                                    ? "primary.main"
                                                    : "text.main",
                                            cursor: "pointer",
                                            color:
                                                activeIndex === index
                                                    ? "primary.main"
                                                    : "text.main",
                                        }}
                                        onClick={() => {
                                            setActiveIndex(index);
                                            document.querySelector('.swiper').swiper.slideToLoop(index);
                                        }}
                                    >
                                        {`0${index + 1}`}
                                    </Typography>
                                ))}
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </>
    );
};

export default TestimonialCard;
